import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[160px] w-full rounded-[14px] border border-transparent bg-[hsl(var(--bg-input))] px-5 py-4 text-base text-[hsl(var(--text-primary))] placeholder:text-[hsl(var(--text-secondary))] focus-visible:outline-none focus-visible:bg-[hsl(var(--bg-card))] focus-visible:border-[hsl(var(--accent-primary))] focus-visible:shadow-[0_0_0_4px_rgba(0,113,227,0.06)] disabled:cursor-not-allowed disabled:opacity-50 transition-all resize-none",
        className
      )}
      style={{
        transitionTimingFunction: 'cubic-bezier(0.2, 0.8, 0.2, 1)'
      }}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
